import React from "react";
import { Form } from "react-bootstrap";
import InputMask from "react-input-mask";

import "../form-elem.css";

interface FormMaskedInputProps {
  onChange: (...args: any) => void;
  onBlur: () => void;
  onPaste?: (args: React.ClipboardEvent) => void;
  value: any;
  name: string;
  type: string;
  inputRef: any;
  disabled?: boolean;
  placeholder?: string;
  error?: any;
  id?: string;
  mask: string;
  maskChar: string;
  maskPlaceholder?: string;
}

function FormMaskedInput({
  onChange,
  onBlur,
  onPaste,
  value,
  name,
  inputRef,
  disabled,
  type,
  placeholder,
  error,
  id,
  mask,
}: FormMaskedInputProps) {
  return (
    <React.Fragment>
      <InputMask
        mask={mask}
        value={value}
        onChange={onChange}
        name={name}
        id={id}
        onBlur={onBlur}
        disabled={disabled}
        placeholder={placeholder}
        autoComplete={"no-auto-complete"}
        onPaste={onPaste}
      >
        {(inputProps: any) => <Form.Control type={type} {...inputProps} ref={inputRef} />}
      </InputMask>
      {error && error.message ? (
        <>
          <Form.Control.Feedback type="invalid">{error.message}</Form.Control.Feedback>
        </>
      ) : null}
    </React.Fragment>
  );
}

export default FormMaskedInput;
